import axios, { AxiosRequestConfig } from "axios";
import Constants from 'lib/Constants';
import AppEvents from "../AppEvents";
import { TaskStatus } from "../data/models/Tasks";
import Cookies from '../utils/Cookies';
import { getLogger } from "../utils/logging";
import EventService from "./EventService";

const { log, warn } = getLogger('ApiService', { color: 'green', enabled: false });

const DEFAULT_TASK_POLL_INTERVAL_MS = 1000;

// Todo: abstract this so it's not confined to only domain requests.
const instance = axios.create({
    baseURL: process.env.API_URL
});

// PORTFOLIO DEMO: route all requests through local dummy data (no-op unless DEMO_MODE).
import { installMockApi } from 'app/demo/mockApi';
installMockApi(instance);

// TODO: add these agents as optional istances for keepAlive requests, or just use fetch?
//const httpAgent = new http.Agent({ keepAlive: true });
//const httpsAgent = new https.Agent({ keepAlive: true });

// const keepAliveInstance = axios.create({
//     baseURL: process.env.API_URL,
//     httpAgent,
//     httpsAgent,
// });

instance.interceptors.request.use(request => {
    //console.log('%c Request:::', 'background: #222; color: #bada55', request);
    request.headers['Authorization'] = `Bearer ${Cookies.get(Constants.ACCESS_TOKEN)}`
    request.headers['Content-Type'] = 'application/json';
    return request;
})

instance.interceptors.response.use(response => {
    //console.log('%c Response:::', 'background: #222; color: #bada55', response);
    return response.data;
})

export default {

    get: async (url, config?: AxiosRequestConfig) => {
        try {
            //if (external) {
            log('GET', url);
            return instance.get(url, config);
            // } else {
            //     return await instance.get(url);
            // }
        } catch(e) {
            if (e.message && e.message.indexOf('Network Error') >= 0) {
                EventService.dispatch(AppEvents.NETWORK_NOT_REACHABLE);
            }
            throw e;
        }
    },

    post: async (url, data, config?: AxiosRequestConfig): Promise<any> => {
        try {
            log('POST', url, data);
            return instance.post(url, data, config);
        } catch(e) {
            if (e.message && e.message.indexOf('Network Error') >= 0) {
                EventService.dispatch(AppEvents.NETWORK_NOT_REACHABLE);
            }
            throw e;
        }
    },

    put: async (url, data) => {
        try {
            log('PUT', url, data);
            return instance.put(url, data)
        } catch(e) {
            if (e.message && e.message.indexOf('Network Error') >= 0) {
                EventService.dispatch(AppEvents.NETWORK_NOT_REACHABLE);
            }
            throw e;
        }
    },

    delete: async (url) => {
        try {
            log('DELETE', url);
            return instance.delete(url)
        } catch(e) {
            if (e.message && e.message.indexOf('Network Error') >= 0) {
                EventService.dispatch(AppEvents.NETWORK_NOT_REACHABLE);
            }
            throw e;
        }
    },

    pollForTaskCompletion: (taskId: string, progressUpdate?: (progress: string) => any, timeout = DEFAULT_TASK_POLL_INTERVAL_MS) => {
        return new Promise((resolve, reject) => {
            try {
                const poll = () => {
                    setTimeout(() => {
                        instance.get(`/tasks/check-status/${taskId}`)
                            .then((res: any) => {
                                log('Task status:', taskId, res);
                                const { status, progress, error, result } = res;
                                if (status === TaskStatus.Finished || status == TaskStatus.FinishedWithErrors) {
                                    return resolve(res);
                                } else if (status === TaskStatus.Error) {
                                    warn(`TASK ERROR:`, error);
                                    return reject({ error, result });
                                } else {
                                    if (progressUpdate) {
                                        progressUpdate(progress);
                                    }
                                    poll();
                                }
                            })
                            .catch((e) => {
                                console.log('pollForTaskCompletion error: ', e, e.message);
                                if (e.message && e.message.indexOf('Network Error') >= 0) {
                                    EventService.dispatch(AppEvents.NETWORK_NOT_REACHABLE);
                                }
                                return reject(e);
                            });
                    }, timeout);
                }

                poll();
            } catch(e) {
                throw e;
            }
        });
    }
};